module.exports = __webpack_public_path__ + "static/media/calendar.286fa7c3.svg";